import Home from '@/pages/index'
import AboutUs from '@/pages/about-us'
import AnnualReport from '@/pages/annual-report'
import AboutUsBoardMembers from '@/pages/about-us-board-members'
import Biographies from '@/pages/biographies'
import FarmingHomepage from '@/pages/farming-homepage'
import FarmingWoodheads from '@/pages/farming-woodheads'
import FarmingWoodheadsLivestock from '@/pages/farming-woodheads-livestock'
import FarmingHowWeWork from '@/pages/farming-how-we-work'
import FarmingBusinessInNumbers from '@/pages/farming-business-in-numbers'
import Investors from '@/pages/investors'
import InvestorsFinancialReports from '@/pages/investors-financial-reports'
import InvestorsAnalysts from '@/pages/investors-analysts'
import InvestorsPresentations from '@/pages/investors-presentations'
import PresentationsVideo from '@/pages/presentations-video'
import PresentationsVideoLive from '@/pages/presentations-video-live'
import CorporateResponsibility from '@/pages/corporate-responsibility'
import CorporateResponsabilityPolicy from '@/pages/corporate-responsibility-policy'
import CorporateKeyFocusAreas from '@/pages/corporate-key-focus-areas'
import MediaCentre from '@/pages/media-centre'
import MediaAssets from '@/pages/media-assets'
import MorrisonsBrands from '@/pages/morrisons-brands'
import ArchivedReleases from '@/pages/archived-releases'
import SeafoodHomepage from '@/pages/seafood-homepage'
import SeafoodResponsibleSourcing from '@/pages/seafood-responsible-sourcing'
import SeafoodWildCapture from '@/pages/seafood-wild-capture'
import SeafoodHealthNutrition from '@/pages/seafood-health-nutrition'
import Article from '@/pages/article'
import CompanyHistory from '@/pages/company-history'
import Investis from '@/pages/investis'
import InvestisShareCenter from '@/pages/investis-share-center'
import InvestisCalculator from '@/pages/investis-calculator'
import ShareholderCommunication from '@/pages/shareholder-communication'
import Christmas from '@/pages/christmas-home'

const routes = [
  { title: 'Home', path: '/', component: Home },
  { title: 'Christmas 2020', path: '/christmas-home', component: Christmas },
  { title: 'Annual Report', path: '/annual-report', component: AnnualReport },
  {
    title: 'Corporate Responsibility',
    path: '/corporate-responsibility',
    component: CorporateResponsibility
  },
  {
    title: 'Corporate Responsibility - Key Focus Areas',
    path: '/corporate-key-focus-areas',
    component: CorporateKeyFocusAreas
  },
  {
    title: 'Corporate Responsibility - Policy',
    path: '/corporate-responsibility-policy',
    component: CorporateResponsabilityPolicy
  },
  {
    title: 'Farming Homepage',
    path: '/farming-homepage',
    component: FarmingHomepage
  },
  {
    title: 'Farming Woodheads',
    path: '/farming-woodheads',
    component: FarmingWoodheads
  },
  {
    title: 'Farming Woodheads Livestock',
    path: '/farming-woodheads-livestock',
    component: FarmingWoodheadsLivestock
  },
  {
    title: 'Farming How We Work',
    path: '/farming-how-we-work',
    component: FarmingHowWeWork
  },
  {
    title: 'Farming Business In Numbers',
    path: '/farming-business-in-numbers',
    component: FarmingBusinessInNumbers
  },
  {
    title: 'Seafood Homepage',
    path: '/seafood-hompage',
    component: SeafoodHomepage
  },
  {
    title: 'Seafood Responsible Sourcing',
    path: '/seafood-responsible-sourcing',
    component: SeafoodResponsibleSourcing
  },
  {
    title: 'Seafood Wild Capture',
    path: '/seafood-wild-capture',
    component: SeafoodWildCapture
  },
  {
    title: 'Seafood Health Nutrition',
    path: '/seafood-health-nutrition',
    component: SeafoodHealthNutrition
  },
  { title: 'About Us', path: '/about-us', component: AboutUs },
  { title: 'Article', path: '/article', component: Article },
  {
    title: 'Board Members',
    path: '/about-us/board-members',
    component: AboutUsBoardMembers
  },
  {
    title: 'Morrisons Brands',
    path: '/morrisons-brands',
    component: MorrisonsBrands
  },
  {
    title: 'Biographies',
    path: '/biographies',
    component: Biographies
  },
  {
    title: 'Company History',
    path: '/company-history',
    component: CompanyHistory
  },
  { title: 'Media Centre', path: '/media-centre', component: MediaCentre },
  {
    title: 'Archived Releases',
    path: '/media-centre/archived-releases',
    component: ArchivedReleases
  },
  {
    title: 'Media Assets',
    path: '/media-centre/assets',
    component: MediaAssets
  },
  { title: 'Investors', path: '/investors', component: Investors },
  {
    title: 'Financial Reports',
    path: '/investors-financial-reports',
    component: InvestorsFinancialReports
  },
  {
    title: 'Analysts',
    path: '/investors-analysts',
    component: InvestorsAnalysts
  },
  {
    title: 'Presentations',
    path: '/investors-presentations',
    component: InvestorsPresentations
  },
  {
    title: 'Presentations Video',
    path: '/presentations-video',
    component: PresentationsVideo
  },
  {
    title: 'Presentations Video Live',
    path: '/presentations-video-live',
    component: PresentationsVideoLive
  },
  {
    title: 'Regulatory News',
    path: '/investis',
    component: Investis
  },
  {
    title: 'Share Centre',
    path: '/investis/share-centre',
    component: InvestisShareCenter
  },
  {
    title: 'Share Calculator',
    path: '/investis/calculator',
    component: InvestisCalculator
  },
  {
    title: 'Shareholder Communication',
    path: '/shareholder-communication',
    component: ShareholderCommunication
  }
]

export default routes
